import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://jmjkznmipcmosmmffaay.supabase.co/'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imptamt6bm1pcGNtb3NtbWZmYWF5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTM4OTIyMDQsImV4cCI6MjAwOTQ2ODIwNH0.mpSbbgLAcZ4C1ULqyeOCdVsb9OXHPzfTCjhC1Eu1G2Q'

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseKey)